// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaxlistTemplate_taxlistTemplateDesc__gke5m * {
    padding: 0;
    /* margin: 0 !important */
}

.TaxlistTemplate_taxlistTemplatemain__J3o9G {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    /* height: 150px; */
    /* background-color: rgb(156, 99, 99); */
    margin: 14px 0px;
    display: none;
    padding: 14px;
    border-radius: 15px;
    border: 1px solid black;
    /* background: url("../../icons/rectangle.png"); */
    position: relative;
    background-repeat: no-repeat;
    background-position: right;
}

.TaxlistTemplate_taxlistTemplateImage__r4Bih span {
    /* border: 1px solid red; */
    /* display: inline-block; */
    /* border: 1px solid red; */
    padding: 6px;
    border-radius: 50%;
    width: 35px;
    /* background: blue; */
    display: flex;
    justify-content: center;
    color: white;
    font-weight: 500;

}



.TaxlistTemplate_taxlistTemplateDesc__gke5m {
    width: 100%;
    padding-left: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding-bottom: 5px;
    /* border: 1px solid rgb(4, 245, 104); */
}

.TaxlistTemplate_taxlistTemplateDesc__gke5m div:nth-child(1) p:nth-child(2) {
    font-weight: 700;
    color: black;
}

.TaxlistTemplate_taxlistTemplateDesc__gke5m div:nth-child(3) p {
    width: 100%;
    font-size: 16px;
}

.TaxlistTemplate_taxlistTemplateDesc__gke5m div:nth-child(3) p span:nth-child(2) {
    color: black;
    font-weight: 700;
    /* font-size: 15px; */
}



.TaxlistTemplate_taxlistTemplateDesc__gke5m>div>p span {
    /* color: #001AD5; */
    font-weight: 500;
    font-size: 16px;

}

.TaxlistTemplate_taxlistTemplateDesc__gke5m p {
    color: black;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    width: 100%;
    text-transform: capitalize;

}

.TaxlistTemplate_taxlistTemplateedit__iI5lk {
    position: absolute;
    right: 10px;
    top: 10px;
    /* background-color: yellow; */
    border-radius: 50%;
    width: 40px;
    height: 40px;
}

.TaxlistTemplate_success__1AodN {
    background-color: blue!important ;
    color: white;
    border: none;
    outline: none;
    margin-top: 7px !important;
    padding: 3px 6px;
    font-size: 14px;
    font-weight: bold;
    width: 83px;
    border-radius: 5px;
}

.TaxlistTemplate_blue__VzLsX {
    background-color: #105293 !important;
    color: white;
    border: none;
    outline: none;
    /* margin-top: 7px !important; */
    padding: 3px 6px;
    font-size: 14px;
    font-weight: bold;
    width: 130px;
}

.TaxlistTemplate_danger__JawKo {
    background-color: red !important;
    border: none;
    outline: none;
    margin-top: 7px !important;
    padding: 3px 6px;
    font-size: 14px;
    font-weight: bold;
    width: 83px;
}

.TaxlistTemplate_categoryWidth__\\+R1gB {
    width: 27%;
}

@media screen and (max-width: 786px) {

    .TaxlistTemplate_categoryWidth__\\+R1gB {
        width: 100%;
    }

    .TaxlistTemplate_taxlistTemplatemain__J3o9G {
        display: block;
        padding: 20px;
    }

    .TaxlistTemplate_taxlistTemplateDesc__gke5m p {
        display: inline-block;
    }

    .TaxlistTemplate_taxlistTemplateedit__iI5lk {
        top: 20px;
    }
}

@media screen and (max-width: 375px) {

    .TaxlistTemplate_taxlistTemplateDesc__gke5m {
        gap: 5px;
    }


    .TaxlistTemplate_taxlistTemplateImage__r4Bih img {
        border-top-left-radius: 14px;
        border-bottom-left-radius: 14px;
    }

    .TaxlistTemplate_taxlistTemplateDesc__gke5m p:nth-child(3) {
        padding-bottom: 0px
    }


}

@media screen and (max-width: 375px) {
    .TaxlistTemplate_taxlistTemplatemain__J3o9G {
        padding: 7px;
    }
}

@media screen and (max-width: 320px) {
    .TaxlistTemplate_taxlistTemplateDesc__gke5m div:nth-child(3) p {

        font-size: 11px;
    }

    .TaxlistTemplate_taxlistTemplateDesc__gke5m div:nth-child(1) {
        font-size: 14px;
    }

    .TaxlistTemplate_taxlistTemplateDesc__gke5m div:nth-child(2) p {
        font-size: 14px;
    }

    .TaxlistTemplate_taxlistTemplateedit__iI5lk {
        top: 4px;
        right: 4px;
    }

    .TaxlistTemplate_taxlistTemplateImage__r4Bih span {
        padding: 3px;
        width: 28px;


    }


}`, "",{"version":3,"sources":["webpack://./src/components/TaxlistTemplate/TaxlistTemplate.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,wCAAwC;IACxC,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kDAAkD;IAClD,kBAAkB;IAClB,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;;AAEpB;;;;AAIA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;AACzB;;;;AAIA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;;AAEnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,0BAA0B;;AAE9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI;QACI,WAAW;IACf;;IAEA;QACI,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;;IAEI;QACI,QAAQ;IACZ;;;IAGA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI;IACJ;;;AAGJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,WAAW;;;IAGf;;;AAGJ","sourcesContent":[".taxlistTemplateDesc * {\n    padding: 0;\n    /* margin: 0 !important */\n}\n\n.taxlistTemplatemain {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    /* height: 150px; */\n    /* background-color: rgb(156, 99, 99); */\n    margin: 14px 0px;\n    display: none;\n    padding: 14px;\n    border-radius: 15px;\n    border: 1px solid black;\n    /* background: url(\"../../icons/rectangle.png\"); */\n    position: relative;\n    background-repeat: no-repeat;\n    background-position: right;\n}\n\n.taxlistTemplateImage span {\n    /* border: 1px solid red; */\n    /* display: inline-block; */\n    /* border: 1px solid red; */\n    padding: 6px;\n    border-radius: 50%;\n    width: 35px;\n    /* background: blue; */\n    display: flex;\n    justify-content: center;\n    color: white;\n    font-weight: 500;\n\n}\n\n\n\n.taxlistTemplateDesc {\n    width: 100%;\n    padding-left: 8px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    padding-bottom: 5px;\n    /* border: 1px solid rgb(4, 245, 104); */\n}\n\n.taxlistTemplateDesc div:nth-child(1) p:nth-child(2) {\n    font-weight: 700;\n    color: black;\n}\n\n.taxlistTemplateDesc div:nth-child(3) p {\n    width: 100%;\n    font-size: 16px;\n}\n\n.taxlistTemplateDesc div:nth-child(3) p span:nth-child(2) {\n    color: black;\n    font-weight: 700;\n    /* font-size: 15px; */\n}\n\n\n\n.taxlistTemplateDesc>div>p span {\n    /* color: #001AD5; */\n    font-weight: 500;\n    font-size: 16px;\n\n}\n\n.taxlistTemplateDesc p {\n    color: black;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n    width: 100%;\n    text-transform: capitalize;\n\n}\n\n.taxlistTemplateedit {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    /* background-color: yellow; */\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n}\n\n.success {\n    background-color: blue!important ;\n    color: white;\n    border: none;\n    outline: none;\n    margin-top: 7px !important;\n    padding: 3px 6px;\n    font-size: 14px;\n    font-weight: bold;\n    width: 83px;\n    border-radius: 5px;\n}\n\n.blue {\n    background-color: #105293 !important;\n    color: white;\n    border: none;\n    outline: none;\n    /* margin-top: 7px !important; */\n    padding: 3px 6px;\n    font-size: 14px;\n    font-weight: bold;\n    width: 130px;\n}\n\n.danger {\n    background-color: red !important;\n    border: none;\n    outline: none;\n    margin-top: 7px !important;\n    padding: 3px 6px;\n    font-size: 14px;\n    font-weight: bold;\n    width: 83px;\n}\n\n.categoryWidth {\n    width: 27%;\n}\n\n@media screen and (max-width: 786px) {\n\n    .categoryWidth {\n        width: 100%;\n    }\n\n    .taxlistTemplatemain {\n        display: block;\n        padding: 20px;\n    }\n\n    .taxlistTemplateDesc p {\n        display: inline-block;\n    }\n\n    .taxlistTemplateedit {\n        top: 20px;\n    }\n}\n\n@media screen and (max-width: 375px) {\n\n    .taxlistTemplateDesc {\n        gap: 5px;\n    }\n\n\n    .taxlistTemplateImage img {\n        border-top-left-radius: 14px;\n        border-bottom-left-radius: 14px;\n    }\n\n    .taxlistTemplateDesc p:nth-child(3) {\n        padding-bottom: 0px\n    }\n\n\n}\n\n@media screen and (max-width: 375px) {\n    .taxlistTemplatemain {\n        padding: 7px;\n    }\n}\n\n@media screen and (max-width: 320px) {\n    .taxlistTemplateDesc div:nth-child(3) p {\n\n        font-size: 11px;\n    }\n\n    .taxlistTemplateDesc div:nth-child(1) {\n        font-size: 14px;\n    }\n\n    .taxlistTemplateDesc div:nth-child(2) p {\n        font-size: 14px;\n    }\n\n    .taxlistTemplateedit {\n        top: 4px;\n        right: 4px;\n    }\n\n    .taxlistTemplateImage span {\n        padding: 3px;\n        width: 28px;\n\n\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"taxlistTemplateDesc": `TaxlistTemplate_taxlistTemplateDesc__gke5m`,
	"taxlistTemplatemain": `TaxlistTemplate_taxlistTemplatemain__J3o9G`,
	"taxlistTemplateImage": `TaxlistTemplate_taxlistTemplateImage__r4Bih`,
	"taxlistTemplateedit": `TaxlistTemplate_taxlistTemplateedit__iI5lk`,
	"success": `TaxlistTemplate_success__1AodN`,
	"blue": `TaxlistTemplate_blue__VzLsX`,
	"danger": `TaxlistTemplate_danger__JawKo`,
	"categoryWidth": `TaxlistTemplate_categoryWidth__+R1gB`
};
export default ___CSS_LOADER_EXPORT___;
